import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePageContent } from '../hooks/usePageContent';
import { usePageTitle } from '../hooks/usePageTitle';

function formatDate(iso) {
    try {
        return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch {
        return iso;
    }
}

export default function BlogPost() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { content: writingContent, loading, error } = usePageContent('writing');

    const posts = writingContent?.posts || [];
    const post = posts.find(p => p.slug === slug);

    usePageTitle(post ? post.title : 'Blog Post');

    if (loading) return <div className="container-narrow py-20">Loading...</div>;
    if (error || !writingContent) return <div className="container-narrow py-20 text-red-600">{error || 'No content found.'}</div>;

    if (!post) {
        return (
            <div className="container-narrow py-20">
                <p className="text-red-600 mb-4">Post not found.</p>
                <button
                    onClick={() => navigate('/writing')}
                    className="text-blue-600 hover:text-blue-700 underline"
                >
                    Back to Writing
                </button>
            </div>
        );
    }

    return (
        <>
            <section className="container-narrow pt-12 md:pt-28 pb-8">
                <button
                    onClick={() => navigate('/writing')}
                    className="text-sm text-fg-muted hover:text-fg mb-6 inline-block"
                >
                    ← Back to Writing
                </button>
                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-6">
                    <span className="font-mono text-[12px] text-fg-soft">
                        {formatDate(post.date)}
                    </span>
                    <span className="text-[12px] text-fg-muted">{post.readingTime} read</span>
                </div>
                <h1 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-tightest text-fg mb-6">
                    {post.title}
                </h1>
            </section>

            <section className="container-narrow pb-14 md:pb-24">
                <div className="max-w-prose">
                    <p className="mb-8 text-[17px] text-fg-muted leading-relaxed">{post.excerpt}</p>
                    <div
                        className="post-body text-[15px] text-fg leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: post.content || '' }}
                    />
                </div>
            </section>
        </>
    );
}
